module.exports = __webpack_public_path__ + "img/58533f5.png";